import { createReducer, on } from '@ngrx/store';

import { IOrderFillDateRange, IOrderFillLocation, IOrderFillPattern } from '@ruby/modules/order-fill/model/order-fill.interface';
import { EOrderFillDateInterval } from '@ruby/shared/enums/order-fill.enums';
import * as OrderFillFiltersActions from '@ruby/shared/inventory-management/order-history-header/store/actions/order-history-filters.actions';
import { IError } from '@ruby/shared/models/request/error.interface';

export const featureKey = 'order-history-filters';

export interface State {
  loadingLocations: boolean;
  loadingPatterns: boolean;
  loadingDateRange: boolean;
  error?: IError;
  locations: Array<IOrderFillLocation>;
  patterns: Array<IOrderFillPattern>;
  dateInterval: { previous?: EOrderFillDateInterval; current?: EOrderFillDateInterval };
  dateRange?: IOrderFillDateRange;
}

export const initialState: State = {
  loadingLocations: false,
  loadingPatterns: false,
  loadingDateRange: false,
  error: undefined,
  locations: [],
  patterns: [],
  dateInterval: { previous: undefined, current: undefined },
  dateRange: undefined
};

export const reducer = createReducer(
  initialState,
  on(OrderFillFiltersActions.loadLocations, state => ({
    ...state,
    loadingLocations: true,
    locations: [],
    error: undefined
  })),
  on(OrderFillFiltersActions.loadLocationsSuccess, (state, action) => ({
    ...state,
    loadingLocations: false,
    locations: action.data
  })),
  on(OrderFillFiltersActions.loadLocationsFailure, (state, action) => ({
    ...state,
    loadingLocations: false,
    error: action.error
  })),
  on(OrderFillFiltersActions.loadPatterns, state => ({
    ...state,
    loadingPatterns: true,
    patterns: [],
    error: undefined
  })),
  on(OrderFillFiltersActions.loadPatternsSuccess, (state, action) => ({
    ...state,
    loadingPatterns: false,
    patterns: action.data
  })),
  on(OrderFillFiltersActions.loadPatternsFailure, (state, action) => ({
    ...state,
    loadingPatterns: false,
    error: action.error
  })),
  on(OrderFillFiltersActions.updateDateInterval, (state, action) => ({
    ...state,
    dateInterval: action.data
  })),
  on(OrderFillFiltersActions.loadDateRange, state => ({
    ...state,
    loadingDateRange: true,
    dateRange: undefined,
    error: undefined
  })),
  on(OrderFillFiltersActions.loadDateRangeSuccess, (state, action) => ({
    ...state,
    loadingDateRange: false,
    dateRange: action.data
  })),
  on(OrderFillFiltersActions.loadDateRangeFailure, (state, action) => ({
    ...state,
    loadingDateRange: false,
    error: action.error
  })),
  on(OrderFillFiltersActions.resetState, () => initialState)
);
